import React from 'react';
import PropTypes from 'prop-types';

class LazyLoading extends React.Component {
  constructor(props) {
    super(props);
    this.onScroll = this.onScroll.bind(this);
  }

  onScroll(e) {
    const { onThresholdExceed, height, threshold } = this.props;
    const { scrollHeight, scrollTop } = e.target;

    if (scrollHeight - (scrollTop + height) < threshold) {
      onThresholdExceed();
    }
  }

  render() {
    const { children, height } = this.props;
    return (
      <div
        style={{ height, overflowY: 'auto' }}
        className="ws-lazy-loading"
        onScroll={this.onScroll}
      >
        {children}
      </div>
    );
  }
}

LazyLoading.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onThresholdExceed: PropTypes.func.isRequired,
  threshold: PropTypes.number,
  height: PropTypes.number,
};

LazyLoading.defaultProps = {
  threshold: 100,
  height: 200,
};

export default LazyLoading;
